import React, { Component } from "react";
import { connect } from "react-redux";
import { openSwAction, changeSwPosiAction, openEstBoringAction } from "../redux/ui/actions";
import html2canvas from "html2canvas";
import { changeSwModeAction, finLrnAction, setUserLicenseAction, setModeleTableAction } from "../redux/app/actions";
import { changeShowChkAction, updateWellsTrAction } from "../redux/boring/actions";
import { updateWLTrAction, updatePompTrAction, updateScreenTrAction } from "../redux/editer/actions";
import { delAllDsAction as delAllDsPosPlAction } from "../redux/pl/actions";
import { delAllDsAction as delAllDsPosCsAction } from "../redux/csLine/actions";
import { delAllDsAction as delAllDsRsltPlAction } from "../redux/rsltPl/actions";
import { delAllDsAction as delAllDsRsltCsAction, changeCsLineAction } from "../redux/csDsp/actions";
import { changeInPredictAction } from "../redux/app/actions";
import GeoInfoList from "./geoInfo/List";
import GeoInfoMain from "./geoInfo/Main";
import BoringList from "./boring/List";
import BoringMain from "./boring/Main";
import BoringCat from "./boring/Cat";
import UserBoring from "./boring/UserBoring";
import ModelArea from "./modelArea/Main";
import EstGeo from "./estGeo/Main";
import TabSw from "./common/TabSw";
import PosPl from "./posPl/Main";
import CSLineList from "./csLine/List";
import CSLineMain from "./csLine/Main";
import EstPl from "./estPl/Main";
import EstCS from "./estCs/Main";
import RsltPl from "./rsltPl/Main";
import CSDsp from "./csDsp/Main";
import SepSw from "./csDsp/SepSw";
import HyperParam from "./HyperParam/Main";
import DBEditor from "./DBEditor/Main";
import IdoModel from "./linkGM/Main";
import EnvData from "./envData/Main";
import Logout from "./logout/Main";
import EstBoring from "./estBoring/Main";

const mapStateToProps = state => {
  return {
    swMode: state.appReducer.swMode,
    finLrn: state.appReducer.finLrn,
    plDs: state.plReducer.ds,
    rsltPlDs: state.rsltPlReducer.ds,
    rsltCsDs: state.csDspReducer.data,
    swCat: state.uiReducer.swCat,
    probSw: state.uiReducer.probSw,
    id: state.userReducer.id,
    pass: state.userReducer.pass,
    coord: state.modelAreaReducer.coord,
    ds: state.boringReducer.dataset,
    csLineDs: state.csLineReducer.dataset,
    userLicense: state.appReducer.userLicense,
    moduleTable: state.appReducer.moduleTable,
    finBoringLoad: state.boringReducer.finBoringLoad,
    dataDownload: state.appReducer.dataDownload,
    gmUrl: state.appReducer.gmUrl,
    modelKind: state.boringReducer.modelKind,
    wlTrData: state.editerReducer.editerWlMeaData,
    pompTrData: state.editerReducer.editerPompMeaData,
    scrTrData: state.editerReducer.editerScreenData,
    gmUrl: state.appReducer.gmUrl,
  };
};

const hData = [
  { id: "geoInfo", text: "地質情報" },
  //{ id: 'boring', text: 'ボーリング' },
  { id: "boring", text: "井戸追加" }, //2024.12.09　パンフレットと名称を統一
  { id: "area", text: "学習領域" },
  { id: "lrn", text: "学習実行" },
  { id: "pos", text: "予測位置" },
  { id: "est", text: "予測実行" },
  { id: "rslt", text: "予測表示" },
  { id: "param", text: "パラメータ" } /*★公開版で削除*/,
  { id: "env", text: "環境データ" },
  { id: "db", text: "データベース" } /*★公開版で削除*/,
  //{id: 'gm', text: 'GEOModeler連動'},
  //{ id: 'gw', text: 'GEOModeler連動' },
  { id: "estb", text: "柱状図予測" }, //2024.12.09　パンフレットと名称を統一
  { id: "gw", text: "解析実行" }, //2024.12.09　パンフレットと名称を統一
  { id: "gemo", text: "地盤モデル作成" },
  //{ id: 'logout', text: 'ログアウト' },
];

class Header extends Component {
  constructor(props) {
    super(props);
    this.openSw = this.openSw.bind(this);
  }
  csIDCoordlst = [];

  waiting = stat => {
    this.props.dispatch(changeInPredictAction(stat));
  };
  /*
   * IDとパスワードからジオモデラーのURLを生成する。
   * @since ando 2023-06-18
   */
  createGMURL() {
    //return '?u_id='+this.props.id+'&u_num=0&u_pass='+this.props.pass
    return "?u_id=" + "gmexpt" + "&u_num=0&u_pass=" + "gmexpt&expt_id=" + this.props.id;
  }

  /*
   *GEOModelerを開く(GM-EXPT)
   * @param
   */
  async linkGM() {
    this.waiting(true);
    this.csIDCoordlst = [];
    this.props.csLineDs.forEach(ID => {
      this.tmpLst = [];
      this.tmpLst.push(ID.ID);
      ID.coords.forEach(coord => {
        this.tmpLst.push(coord[1]);
        this.tmpLst.push(coord[2]);
      });
      this.csIDCoordlst.push(this.tmpLst);
    });
    const data = {
      type: "expt",
      zoom: window.getZoom(),
      csLine: -1,
      csIDCoord: this.csIDCoordlst,
      range: {
        x1: this.props.coord[2],
        x2: this.props.coord[3],
        y1: this.props.coord[1],
        y2: this.props.coord[0],
      },
      userID: this.props.id,
    };
    window.open(this.props.gmUrl);
    const origin = window.location.origin;
    const search = window.location.search;
    await fetch(`/api/linkGM/${search}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(res => res.json())
      .then(res => {
        console.log("doExe done");
        this.waiting(false);
      })
      .catch(err => {
        console.log(err.message);
        alert("サーバーエラー");
        this.waiting(false);
      });
    //GEOModelerを開く

    //V2ログイン回避
  }

  /*
   * クリックされたメニューとライセンスから使用可否を返す。
   * @since ando 2024-03-08
   */
  retModuleUse(id) {
    let chk = this.props.moduleTable;
    //console.log(chk)
    let booleanValue = chk[id][this.props.userLicense + 1].toUpperCase() === "TRUE";
    return booleanValue;
  }

  /*
   * 複数井戸をすべて削除する
   * @since ando 2025-05-12
   */
  deleteAllWells() {
    this.props.dispatch(updateWellsTrAction([]));
    this.props.dispatch(openEstBoringAction(null));
    //紐付いている詳細情報も削除する
    // wellsTrData の更新
    if (this.props.wlTrData[1000]) {
      const updatedWLTrData = {
        ...this.props.wlTrData,
        [1000]: {},
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updateWLTrAction(updatedWLTrData));
    }

    if (this.props.pompTrData[1000]) {
      const updatedPompTrData = {
        ...this.props.pompTrData,
        [1000]: {},
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updatePompTrAction(updatedPompTrData));
    }

    if (this.props.scrTrData[1000]) {
      const updatedScrTrData2 = {
        ...this.props.scrTrData,
        [1000]: {},
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updateScreenTrAction(updatedScrTrData2));
    }
    this.setState({ selectedCheckbox: null });
    window.removeWellsData();
  }

  /*
   * サブウィンドウを開く
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  openSw(e) {
    let id = e.currentTarget.id;
    let swMode = 1;

    const cancelSw = mes => {
      window.alert(mes);
      swMode = 0;
      id = null;
    };
    //データダウンロード中だったら
    if (!this.props.finBoringLoad) {
      cancelSw("データダウンロードが完了するまで使用できません。");
    }

    if (this.props.swCat != null) {
      //すでに開いているサブウィンドウがあった場合、閉じさせる。
      for (let i = 0; i < hData.length; i++) {
        if (hData[i].id === this.props.swCat && id !== this.props.swCat) {
          return cancelSw(hData[i].text + "ウィンドウを閉じてから開いてください。");
        } else if (id === this.props.swCat) {
          this.props.dispatch(changeSwPosiAction(true));
        }
      }
    }

    //if (!this.retModuleUse(id)) {
    //    cancelSw('ご利用のライセンスでは使用できません。');
    //}

    switch (id) {
      case "boring":
        break;

      case "area":
        if (this.props.finLrn || window.getCP()[0] != 0) {
          let answer = window.confirm("学習領域を再設定する場合、学習結果・予測位置・予測結果の\nデータが削除されます。よろしいですか。");
          if (answer) {
            window.removeModelArea();
            window.removeModelMarker();
            window.changeCP(0, 0);
            window.setSelBoringNum(0);
            this.props.dispatch(finLrnAction(false));
            //予測位置データ削除
            window.delAllCsLine();
            this.props.dispatch(delAllDsPosPlAction());
            this.props.dispatch(delAllDsPosCsAction());
            //予測結果データ削除
            this.props.dispatch(delAllDsRsltPlAction());
            this.props.dispatch(delAllDsRsltCsAction());
            //断面予測結果IDを0にする
            this.props.dispatch(changeCsLineAction(0));
          } else {
            swMode = 0;
            id = null;
          }
        }
        break;
      case "lrn":
        if (!window.existModelArea()) {
          cancelSw("学習領域を作成してください。");
          //学習領域内のボーリング数が0の時
        } else if (window.getSelBoringNum() == 0) {
          cancelSw("学習領域内にボーリングが存在しません。");
        }
        break;
      case "pos":
        if (!this.props.finLrn) cancelSw("学習を実行してください。");
        break;
      case "est":
        if (!this.props.plDs.length && !window.existCsLine()) cancelSw("予測位置を作成してください。");
        break;
      case "rslt":
        if (!this.props.rsltPlDs.length && !this.props.rsltCsDs.length) cancelSw("予測を実行してください。");
        break;
      case "gm":
        if (!this.props.finLrn) {
          cancelSw("学習を実行してください。");
        } else {
          this.csIDCoordlst = [];
          this.props.csLineDs.forEach(ID => {
            this.tmpLst = [];
            this.tmpLst.push(ID.ID);
            ID.coords.forEach(coord => {
              this.tmpLst.push(coord[1]);
              this.tmpLst.push(coord[2]);
            });
            this.csIDCoordlst.push(this.tmpLst);
          });
          this.linkGM();
          swMode = 0;
          id = null;
        }

        break;
      case "estb":
        //予測データが存在する場合予測データが削除される
        if (this.props.plDs.length > 0 || window.existCsLine()) {
          let answer = window.confirm("GM-WELLを使用する場合、予測位置・予測結果の\nデータが削除されます。よろしいですか。");
          if (answer) {
            window.removeModelArea();
            window.removeModelMarker();
            window.changeCP(0, 0);
            this.props.dispatch(finLrnAction(false));
            //予測位置データ削除
            window.delAllCsLine();
            this.props.dispatch(delAllDsPosPlAction());
            this.props.dispatch(delAllDsPosCsAction());
            //予測結果データ削除
            this.props.dispatch(delAllDsRsltPlAction());
            this.props.dispatch(delAllDsRsltCsAction());
            //断面予測結果IDを0にする
            this.props.dispatch(changeCsLineAction(0));
          } else {
            swMode = 0;
            id = null;
          }
        }
        if (this.props.modelKind == 3) {
          let answer = window.confirm("作成した井戸位置、流域界が削除されます。よろしいですか。");

          if (answer) {
            //井戸位置削除
            window.removeModelArea();
            window.removeModelMarker();
            window.changeCP(0, 0);
            //流域界削除
            window.deleteSelectedWaterShed();
            //複数井戸削除
            this.deleteAllWells();
            window.setSelBoringNum(0);
            window.setPredAcc("%");
            window.setAnalyAcc("%");
            window.setNearestPompData("-");
          } else {
            swMode = 0;
            id = null;
          }
        }

        break;
      case "gw":
        if (window.getCP()[0] == 0 && window.getCP()[1] == 0) {
          cancelSw("柱状図予測で井戸位置を作成してください。");
        }
        //予測データが存在する場合予測データが削除される
        if (this.props.plDs.length > 0 || window.existCsLine()) {
          let answer = window.confirm("GM-WELLを使用する場合、予測位置・予測結果の\nデータが削除されます。よろしいですか。");
          if (answer) {
            window.removeModelArea();
            window.removeModelMarker();
            window.changeCP(0, 0);
            this.props.dispatch(finLrnAction(false));
            //予測位置データ削除
            window.delAllCsLine();
            this.props.dispatch(delAllDsPosPlAction());
            this.props.dispatch(delAllDsPosCsAction());
            //予測結果データ削除
            this.props.dispatch(delAllDsRsltPlAction());
            this.props.dispatch(delAllDsRsltCsAction());
            //断面予測結果IDを0にする
            this.props.dispatch(changeCsLineAction(0));
          } else {
            swMode = 0;
            id = null;
          }
        }

        break;
      case "gemo":
        //サーバーからGM-EXPTに必要なデータをジオモデラーに送る。
        if (!window.existModelArea()) {
          cancelSw("学習領域を作成してください。");
        } else if (!this.props.rsltCsDs.length) {
          cancelSw("断面予測を実行してください。");
        } else {
          this.linkGM();
          swMode = 0;
          id = null;
        }
        break;
      case "logout":
        break;
    }

    this.props.dispatch(openSwAction(id));
    this.props.dispatch(changeSwModeAction(swMode));
  }
  render() {
    let cont = null;
    switch (this.props.swCat) {
      case "geoInfo":
        cont = <GeoInfoList />;
        break;
      case "geoInfoMain":
        cont = <GeoInfoMain />;
        break;
      case "boring":
        cont = <BoringList />;
        break;
      case "boringMain":
        cont = <BoringMain />;
        break;
      case "boringCat":
        cont = <BoringCat />;
        break;
      case "userBoring":
        cont = <UserBoring />;
        break;
      case "area":
        cont = <ModelArea />;
        break;
      case "lrn":
        cont = <EstGeo />;
        break;
      case "pos":
        cont = <TabSw title="予測位置" ID="pos_tab" plComp={<PosPl />} csComp={<CSLineList />} />;
        break;
      case "csLine":
        cont = <CSLineMain />;
        break;
      case "est":
        cont = <TabSw title="予測実行" ID="pre_tab" plComp={<EstPl />} csComp={<EstCS />} />;
        break;
      case "rslt":
        cont = <TabSw title="予測表示" ID="rslt_tab" plComp={<RsltPl />} csComp={<CSDsp />} />;
        break;
      case "param":
        cont = <HyperParam />;
        break;
      case "env":
        cont = <EnvData />;
        break;
      case "db":
        cont = <DBEditor />;
        break;
      case "estb":
        cont = <EstBoring />;
        break;
      case "gw":
        cont = <IdoModel />;
        break;
      case "ge":
        break;
      case "logout":
        cont = <Logout />;
        break;
    }

    return (
      <div>
        <div className="Header">
          <div className="Header__logo">
            {this.props.userLicense == 0 && ( //開発者
              <div>
                <span className="icon-logo" onClick={this.changeVis}>
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                </span>
                <span className="icon-gmai"></span>
              </div>
            )}
            {this.props.userLicense == 1 && ( //GM-AI
              <div>
                <span className="icon-logo" onClick={this.changeVis}>
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                </span>
                <span className="icon-gmai"></span>
              </div>
            )}
            {this.props.userLicense == 2 && ( //GM-WELL
              <div>
                <span className="icon-gwh" onClick={this.changeVis}>
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                  <span className="path7"></span>
                  <span className="path8"></span>
                  <span className="path9"></span>
                </span>
                <span className="icon-gmwl"></span>
              </div>
            )}
            {this.props.userLicense == 3 && ( //GM-WELL 個別で分岐させないとアイコンが表示されないため
              <div>
                <span className="icon-gwh" onClick={this.changeVis}>
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                  <span className="path7"></span>
                  <span className="path8"></span>
                  <span className="path9"></span>
                </span>
                <span className="icon-gmwl"></span>
              </div>
            )}
            {this.props.userLicense == 4 && ( //GM-WELL 個別で分岐させないとアイコンが表示されないため
              <div>
                <span className="icon-gwh" onClick={this.changeVis}>
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                  <span className="path7"></span>
                  <span className="path8"></span>
                  <span className="path9"></span>
                </span>
                <span className="icon-gmwl"></span>
              </div>
            )}
            {this.props.userLicense == 5 && ( //GM-EXPT
              <div>
                <span className="icon-ge" onClick={this.changeVis}>
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                </span>
                <span className="icon-gmex"></span>
              </div>
            )}
          </div>
          <ul className="Header__btnWrap">
            {hData.map(el => {
              if (this.props.moduleTable[el.id][this.props.userLicense + 1].toUpperCase() === "FALSE") {
                return null; // ループをスキップ
              }
              return (
                <li id={el.id} className="Header__btn" key={el.id} title={el.text} onClick={this.openSw}>
                  <div className="l-row">
                    <span className={"icon-" + el.id}>
                      {el.id === "rslt" && (
                        <span className="icon-rslt">
                          <span className="path1"></span>
                          <span className="path2"></span>
                          <span className="path3"></span>
                          <span className="path4"></span>
                        </span>
                      )}
                      {/*
                                            {el.id === 'gw' && <span className="icon-gwh"><span className="path1"></span><span className="path2"></span><span className="path3"></span>
                                                <span className="path4"></span><span className="path5"></span><span className="path6"></span>
                                                <span className="path7"></span><span className="path8"></span><span className="path9"></span></span>}
                                            */}
                      {el.id === "ge" && (
                        <span className="icon-ge">
                          <span className="path1"></span>
                          <span className="path2"></span>
                          <span className="path3"></span>
                        </span>
                      )}
                    </span>
                    <p>{el.text}</p>
                  </div>
                </li>
              );
            })}
          </ul>
          {!this.props.finBoringLoad && (
            <div className={this.props.finBoringLoad ? null : "LoaderWrap3 l-center"}>
              <div className="download">データダウンロード: {this.props.dataDownload} ％</div>
            </div>
          )}
        </div>

        {cont}
        {this.props.probSw ? <SepSw /> : null}
      </div>
    );
  }
}

export default connect(mapStateToProps)(Header);
